<template>
  <v-flex
    v-if="getSheetDescriptionQuestions.hasOwnProperty('family_beauty')"
    id="familyBeauty"
    class="question"
  >
    <h2
      v-if="getSheetDescriptionQuestions.family_beauty.hasOwnProperty('label')"
      class="header"
      :class="{ required: getSheetDescriptionQuestions.family_beauty.required }"
    >
      {{ getSheetDescriptionQuestions.family_beauty.label }}
    </h2>
    <v-layout
      row
      justify-space-between
      wrap
    >
      <v-flex
        xs12
        sm5
      >
        <v-layout
          justify-space-between
          column
        >
          <v-flex xs12>
            <div
              v-if="getSheetDescriptionQuestions.family_beauty.hasOwnProperty('text')"
              class="content"
            >
              <p
                v-for="(text, index) in getSheetDescriptionQuestions.family_beauty.text"
                :key="index"
                class="mb-0"
                v-html="text"
              />
            </div>
          </v-flex>
          <v-flex
            xs12
            mt-3
          >
            <div>
              <p class="mb-0 f-14">
                {{ $t('description.tips') }}
              </p>
              <p class="mb-0 f-2 fw-600">
                {{ $t('description.family_beauty.tips_title') }}
              </p>
            </div>
            <div class="mt-3 mb-3">
              <div
                v-for="(item, index) in sheetOneMeetingResources"
                :key="index"
              >
                <div v-if="getValueByProperty(item.property) != null">
                  <p class="mb-0 f-1 fw-600 mt-2">
                    {{ item.number }}. {{ item.label }}
                  </p>
                  <p class="mb-0 f-14">
                    {{ getValueByProperty(item.property) }}
                  </p>
                </div>
              </div>
            </div>
            <div class="mt-1">
              <p class="mb-0 f-2 fw-600">
                {{ $t('description.family_beauty.second_tips_title') }}
              </p>
            </div>
            <div class="mt-3 mb-3">
              <ul>
                <template v-for="(item, index) in familyResources">
                  <li
                    v-if="item.id !== 143"
                    :key="index"
                  >
                    {{ item.description }}
                  </li>
                  <li
                    v-else
                    :key="'elsecondition_' + index"
                  >
                    {{ item.description }}: {{ reflectionResourceData.otherResources }}
                  </li>
                </template>
              </ul>
            </div>
            <v-divider />
            <div
              v-if="getSheetDescriptionQuestions.family_beauty.hasOwnProperty('more_help')"
              class="mt-3"
            >
              <v-flex>
                <p class="mb-2 f-1 fw-600">
                  {{ getSheetDescriptionQuestions.family_beauty.more_help.label }}
                </p>
              </v-flex>
              <v-flex
                v-for="(text, index) in getSheetDescriptionQuestions.family_beauty.more_help.text"
                :key="index"
              >
                <span v-html="text" />
              </v-flex>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex
        v-if="getSheetDescriptionQuestions.family_beauty.hasOwnProperty('helpful_questions')"
        xs12
        sm6
        :mt-3="xsOnly"
      >
        <p class="f-1 mb-1">
          {{ getSheetDescriptionQuestions.family_beauty.helpful_questions.label }}
        </p>
        <p
          v-for="(text, index) in getSheetDescriptionQuestions.family_beauty.helpful_questions.text"
          :key="index"
          class="mb-0"
        >
          {{ text }}
        </p>
        <v-textarea
          id="familyBeauty"
          v-model.trim="familyBeauty"
          v-validate="{
            ...limitRegularField(getSheetDescriptionQuestions.family_beauty.required, FIELD_LIMIT)
          }"
          name="familyBeauty"
          auto-grow
          rows="8"
          class="mt-3"
          :placeholder="$t('label.text')"
          :error-messages="errors.collect('familyBeauty')"
          data-vv-name="familyBeauty"
          :data-vv-as="$t('description.family_beauty.title')"
          :disabled="readOnly"
          @focusout="reValidate"
        />
        <p
          class="f-14 mt-1 ml-1"
          :class="{ 'sz_red--text': errors.collect('familyBeauty').length > 0 }"
        >
          {{
            $t('message.info_text_length', {
              stringMin: FIELD_LIMIT,
              stringLength: familyBeauty != null ? familyBeauty.length : 0
            })
          }}
        </p>
      </v-flex>
    </v-layout>
    <v-dialog
      v-model="barriersDialog"
      fullscreen
      hide-overlay
      :transition="false"
    >
      <v-card>
        <v-card-title>
          <v-layout justify-space-between>
            <v-flex shrink>
              <p class="mb-0 pt-2 f-2">
                {{ $t('description.preview') }}
              </p>
            </v-flex>
            <v-flex shrink>
              <v-icon
                large
                class="clickable"
                @click.prevent="barriersDialog = false"
              >
                clear
              </v-icon>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-layout
          justify-center
          mt-3
        >
          <v-flex
            xs12
            sm6
            :mx-3="xsOnly"
          >
            <QuestionsBarriers
              read-only
              :end-button="{ to: 'sheet-one-meeting', text: $t('description.go_to_sheet_one') }"
            />
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="joblessDialog"
      fullscreen
      hide-overlay
      :transition="false"
    >
      <v-card>
        <v-card-title>
          <v-layout justify-space-between>
            <v-flex shrink>
              <p class="mb-0 pt-2 f-2">
                {{ $t('description.preview') }}
              </p>
            </v-flex>
            <v-flex shrink>
              <v-icon
                large
                class="clickable"
                @click.prevent="joblessDialog = false"
              >
                clear
              </v-icon>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-layout
          justify-center
          mt-3
        >
          <v-flex
            xs12
            sm6
            :mx-3="xsOnly"
          >
            <QuestionsJobless
              read-only
              :end-button="{ to: 'sheet-one-meeting', text: $t('description.go_to_sheet_one') }"
              hide-about-sixty
            />
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <descripionExamplesDialog v-model="examplesDialog" />
  </v-flex>
</template>

<script>
import QuestionsBarriers from '@/components/sheet/sheetOne/questions/QuestionsBarriers';
import QuestionsJobless from '@/components/sheet/sheetOne/questions/QuestionsJobless';
import { createHelpers } from 'vuex-map-fields';

import descripionExamplesDialog from '@/components/description/descripionExamplesDialog';
import listenersManager from '@/mixins/sheet/listenersManager';
import sheetResourcesGetter from '@/mixins/sheet/sheetResourcesGetter';
import sheetValidationRules from '@/mixins/sheet/sheetValidationRules';
import { mapGetters } from 'vuex';

import has from 'lodash.has';
const { mapFields } = createHelpers({
    getterType: 'description/getFields',
    mutationType: 'description/updateFields'
});

export default {
    name: 'FamilyBeauty',
    components: { QuestionsJobless, QuestionsBarriers, descripionExamplesDialog },
    mixins: [listenersManager, sheetResourcesGetter, sheetValidationRules],
    inject: ['$validator'],
    props: {
        resourceData: {
            default: () => {
                return [];
            }
        },
        reflectionResourceData: {
            default: () => {
                return [];
            }
        },
        readOnly: {
            default: false,
            type: Boolean
        }
    },
    data () {
        return {
            FIELD_LIMIT: 400,
            barriersDialog: false,
            joblessDialog: false,
            examplesDialog: false
        };
    },
    computed: {
        ...mapFields(['familyBeauty']),
        ...mapGetters('sheet', [
            'getSheetDescriptionQuestions',
            'getFamilyResourcesQuestions',
            'getResourcesQuestions'
        ]),
        xsOnly () {
            return this.$vuetify.breakpoint.xsOnly;
        },
        familyResources () {
            const _sheetResources = this.getResources(this.getResourcesQuestions?.has_resources) ?? [];
            const _res = [];
            this.reflectionResourceData?.hasResources.forEach((el) => {
                _sheetResources.forEach((obj) => {
                    if (el === obj.id) {
                        _res.push(obj);
                    }
                });
            });
            return _res;
        },
        isCurrentEdition () {
            return this.$store.getters['family/isCurrentEdition'];
        },
        sheetOneMeetingResources () {
            const result = [];
            const list = [
                { label: 'what_you_enjoy', property: 'whatYouEnjoy', number: '1' },
                { label: 'solutions', property: 'solutions', number: '2' },
                { label: 'family_skills', property: 'familySkills', number: '3' },
                { label: 'grateful_for', property: 'gratefulFor', number: '4' },
                { label: 'thoughts_about_future', property: 'thoughtsAboutFuture', number: '5a' },
                { label: 'dream_about', property: 'dreamAbout', number: '5b' }
            ];

            list.forEach((el) => {
                if (has(this.getFamilyResourcesQuestions, el.label)) {
                    result.push({
                        label: this.getFamilyResourcesQuestions[el.label].label,
                        property: el.property,
                        number: el.number
                    });
                }
            });

            return result;
        },
        familyBeautyExamples () {
            return document.querySelector('[ref="familyBeautyExamples"]');
        },
        sheetSectionBarriers () {
            return document.querySelector('[ref="sheetSectionBarriers"]');
        },
        sheetSectionJobless () {
            return document.querySelector('[ref="sheetSectionJobless"]');
        }
    },
    mounted () {
        if (!this.isCurrentEdition) {
            this.familyBeautyExamples && this.familyBeautyExamples.setAttribute('disabled', 'disabled');
            this.sheetSectionBarriers && this.sheetSectionBarriers.setAttribute('disabled', 'disabled');
            this.sheetSectionJobless && this.sheetSectionJobless.setAttribute('disabled', 'disabled');
        }

        this.familyBeautyExamples && this.setListener(this.familyBeautyExamples, this.openExamples);
        this.sheetSectionBarriers &&
      this.setListener(this.sheetSectionBarriers, this.openBarriersDialog);
        this.sheetSectionJobless && this.setListener(this.sheetSectionJobless, this.openJoblessDialog);
    },
    beforeDestroy () {
        this.familyBeautyExamples &&
      this.removeListener(this.familyBeautyExamples, 'click', this.openExamples);
        this.sheetSectionBarriers &&
      this.removeListener(this.sheetSectionBarriers, 'click', this.openBarriersDialog);
        this.sheetSectionJobless &&
      this.removeListener(this.sheetSectionJobless, 'click', this.openJoblessDialog);
    },
    methods: {
        getValueByProperty (prop) {
            if (has(this.resourceData, prop)) {
                return this.resourceData[prop];
            }
            return null;
        },
        openExamples (e) {
            e.preventDefault();
            this.examplesDialog = true;
        },
        openBarriersDialog (e) {
            e.preventDefault();
            this.barriersDialog = true;
        },
        openJoblessDialog (e) {
            e.preventDefault();
            this.joblessDialog = true;
        },
        reValidate () {
            this.$validator.validate('familyBeauty', this.familyBeauty.trim());
        }
    }
};
</script>

<style scoped></style>
